<template>
  <div class="reports-view">
    <HeaderControlsReport ref="headerControlsReport" @reportTypeChanged="setReportType" @reportGenerated="renderGraphs" @reportFilterUpdated="filterUpdate"  :namespace="namespace" />
    <div class="container-fluid fixed-top-bar-padding report-wrapper">
      <div class="deliverable-header">
        <h2 class="d-flex d-md-inline">
          <div class="media-call-icon">
            <img src="@/csmworkflow/img/report-icon.svg" />
          </div>
          <span>
            Reports
            <span class="report-title d-block d-md-inline"> <span class="text-primary d-none d-md-inline">></span> {{ reportType.name }}</span>
          </span>
        </h2>
      </div>
      
      
      <div class="report-graphs" v-show="showReport">
        <div class="report-header">
          <div class="row">
            <div class="col-12 col-md-5 stats-border breakpoint__fix">
              <div class="report-stats">
                <span>
                  <span class="stats-number">{{ totalCalls }}</span>
                  <span class="stats-name"> Calls</span>
                </span>
                <span class="stats-name-wrap" v-if="reportType.id != 'fullList' && reportType.id != 'duration'">
                  <span class="stats-number">{{ totalDataType }}</span>
                  <span class="stats-name"> {{ reportDataType }}<span v-if="totalDataType>1">s</span></span> 
                </span>
              </div>
              <!-- <div class="report-heading">Report</div> -->
              <!-- <div class="report-title" v-show="!noData">{{ reportType.name }}</div> -->
            </div>
            <div class="col-12 col-md-7 controls text-center text-lg-right breakpoint__fix">
              <a href="#" class="btn btn-theme mr-2" @click="exportReport('excel')" :class="!filterQuery.filterByDateCreated ? 'margin-15' : ''" v-show="!noData">
                <span :class="filterQuery.filterByDateCreated ? 'download-text' : ''">Download Excel</span> <i class="fas fa-file-excel text-primary"></i>
              </a>
              <a href="#" v-if="false" class="btn btn-theme mr-2" @click="exportReport('pdf')" :class="!filterQuery.filterByDateCreated ? 'margin-15' : ''" v-show="!noData">
                <span :class="filterQuery.filterByDateCreated ? 'download-text' : ''">Download PDF</span> <i class="fas fa-file-pdf text-primary"></i>
              </a>
              <div class="date-shifter" v-show="filterQuery.filterByDateCreated">
                <b-button @click="prevDate()" variant="theme" class="prev">
                  <i class="fas fa-chevron-left"></i>
                </b-button><span class="date-holder">{{filterQuery.dateCreatedRange ? $moment(filterQuery.dateCreatedRange.startDate).format('MMM DD') : ''}} - {{filterQuery.dateCreatedRange ? $moment(filterQuery.dateCreatedRange.endDate).format('MMM DD') : ''}}</span><b-button @click="nextDate()" variant="theme" class="next">
                  <i class="fas fa-chevron-right"></i>
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <perfect-scrollbar v-if="reportType.id == 'fullList'">
          <div ref="reportData"></div>
        </perfect-scrollbar>
        <div v-else ref="reportData"></div>
        <!-- <div ref="reportData"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import HeaderControlsReport from "../components/common/HeaderControlsReport";
import toast from '../toast'

export default {
  data() {
    return {
    	namespace:"",
      reportType: {name: 'Calls by Department', id: 'callsByDepartment'},
      showReport: false,
      noData: true,
      pageNumber: 0,
      totalCalls: 0,
      totalDataType: 0,
      reportDataType: '',
      filterQuery: {}
    };
  },
  components: {
    HeaderControlsReport
  },
  methods: {
    prevDate() {
      this.$refs.headerControlsReport.prevDate()
    },
    nextDate() {
      this.$refs.headerControlsReport.nextDate()
    },
    renderGraphs(response) {
      toast.hide();
      $('.csm-loader').hide();
      this.showReport = true;

      this.totalCalls = response.total;
      this.totalDataType = response.dataTotal;
      this.reportDataType = response.dataType;

      if(response.html) {
        let that = this;

        setTimeout(function() {
          that.noData = false;
          that.$refs.reportData.innerHTML = response.html;
          eval(response.script);
        }, 10);
      } else {
        this.noData = true;
        this.$refs.reportData.innerHTML = '<h3 class="text-center no-report-data">Unfortunately, there is no dataset matching your filter criteria.</h3>';
      }
    },
    setReportType(reportType) {
      this.reportType = reportType;
    },
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery;
    },
    exportReport(exportType) {
      let that = this;
      toast.info('Preparing report for download...');
      this.$store.dispatch("downloadReport", {reportType: this.reportType.id, page: this.pageNumber, exportType: exportType}).then(resp => {
        toast.hide();
        $('.csm-loader').hide();
        that.forceFileDownload(resp);
      }).catch(error => {
        toast.hide();
      });
    },
    forceFileDownload(response) {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = 'exported-reports/' + response;
      a.download = response;
      document.body.appendChild(a);
      a.click();
    }
  },
  mounted() {
    let vm = this;
    $('body').on('click', '.page-link', function(e) {
      e.preventDefault();
      let url = $(this).attr('href');
      let hashes = url.slice(url.indexOf('?') + 1).split('&');
      hashes = hashes[0].split('=');
      vm.pageNumber = hashes[1];
      toast.info('Generating report...');
      vm.$store.dispatch('getReport', {reportType: vm.reportType.id, page: vm.pageNumber}).then(resp => {
        toast.hide();
        vm.renderGraphs(resp);
      })
    })
    // let that = this;
    // this.$store.dispatch("getReport", {reportType: 'callsByDepartment'}).then(function(response) {
    //   that.$refs.reportData.innerHTML = response.html;
    //   eval(response.script);
    // });
  }
};
</script>